import { __assign, __awaiter, __extends, __generator } from "tslib";
import React, { PureComponent } from 'react';
import { isArray, isObject } from '@ekuaibao/helpers';
import { Fetch } from '@ekuaibao/fetch';
import { Resource } from '@ekuaibao/fetch';
var aiResult = new Resource('/api/extend/ai');
export var FetchAttachment = function (WrappedComponent) {
    return (function (_super) {
        __extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            var value = props.value;
            _this.state = { value: value };
            return _this;
        }
        class_1.prototype.componentWillReceiveProps = function (nextProps) {
            return __awaiter(this, void 0, void 0, function () {
                var value, onChange_1, values_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(nextProps.value !== this.props.value && needFetchData(nextProps))) return [3, 2];
                            value = nextProps.value, onChange_1 = nextProps.onChange;
                            return [4, fetchAttachment(value, true)];
                        case 1:
                            values_1 = _a.sent();
                            this.setState({ value: values_1 }, function () { return onChange_1 && onChange_1(values_1); });
                            _a.label = 2;
                        case 2: return [2];
                    }
                });
            });
        };
        class_1.prototype.componentDidMount = function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a, value, onChange, values_2;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = this.props, value = _a.value, onChange = _a.onChange;
                            if (!needFetchData(this.props)) return [3, 2];
                            return [4, fetchAttachment(value)];
                        case 1:
                            values_2 = _b.sent();
                            this.setState({ value: values_2 }, function () { return onChange && onChange(values_2); });
                            _b.label = 2;
                        case 2: return [2];
                    }
                });
            });
        };
        class_1.prototype.render = function () {
            var newProps = {};
            if (needFetchData(this.props)) {
                newProps = __assign({}, this.state);
            }
            return React.createElement(WrappedComponent, __assign({}, this.props, newProps));
        };
        return class_1;
    }(PureComponent));
};
export function fetchAttachment(value, isUpdate) {
    if (isUpdate === void 0) { isUpdate = false; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, fileIds, fileMap, res_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!value) {
                        return [2, value];
                    }
                    _a = getFileIds(value, isUpdate), fileIds = _a.fileIds, fileMap = _a.fileMap;
                    if (!fileIds.length) return [3, 2];
                    return [4, Fetch.POST("/api/v1/attachment/attachments/ids", null, { body: { ids: fileIds } }, {
                            hiddenLoading: true
                        })];
                case 1:
                    res_1 = _b.sent();
                    return [2, fileIds.reduce(function (arr, id) {
                            var item = res_1.items.find(function (v) { return v.id === id; });
                            return item ? arr.concat(__assign(__assign({}, fileMap[item.id]), { fileId: item })) : arr;
                        }, [])];
                case 2: return [2, Promise.resolve(value)];
            }
        });
    });
}
function needFetchData(props) {
    var field = props.field, value = props.value;
    if (!value || !field) {
        return false;
    }
    if (field.dataType.type !== 'list' && field.dataType.elemType.type !== 'attachment') {
        return false;
    }
    if (isArray(value)) {
        var hasDingPan = value.find(function (line) { var _a; return (_a = line.key) === null || _a === void 0 ? void 0 : _a.startsWith('DP:'); });
        if (hasDingPan) {
            return false;
        }
        return !!value.find(function (line) { return !isObject(line.fileId) && !line.url; });
    }
    return false;
}
function getFileIds(values, isUpdate) {
    if (!values || !values.length) {
        return { fileIds: [], fileMap: {} };
    }
    var fileIds = [];
    var fileMap = {};
    values
        .filter(function (value) { return !value.key.startsWith('DP:') && !isUpdate; })
        .forEach(function (line) {
        if (line.fileId && !isObject(line.fileId)) {
            fileIds.push(line.fileId);
            fileMap[line.fileId] = line;
        }
    });
    return { fileIds: fileIds, fileMap: fileMap };
}
export var fetchAttachmentAIResult = function (_a) {
    var attachmentKey = _a.attachmentKey, fields = _a.fields, datalinkFieldMap = _a.datalinkFieldMap, specificationId = _a.specificationId, feeTypeId = _a.feeTypeId, flowType = _a.flowType;
    return __awaiter(void 0, void 0, void 0, function () {
        var initialResponse, id, maxDuration, pollInterval, startTime;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, aiResult.POST("/flow/autoFill", {
                        key: attachmentKey,
                        fields: fields,
                        datalinkFieldMap: datalinkFieldMap,
                        specificationId: specificationId,
                        feeTypeId: feeTypeId,
                        flowType: flowType
                    })];
                case 1:
                    initialResponse = _b.sent();
                    id = initialResponse.id;
                    if (!id) {
                        throw new Error('AI 接口返回的 ID 为空');
                    }
                    maxDuration = 3 * 60 * 1000;
                    pollInterval = 6000;
                    startTime = Date.now();
                    return [2, new Promise(function (resolve, reject) {
                            var poll = function () { return __awaiter(void 0, void 0, void 0, function () {
                                var result, error_1;
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            _b.trys.push([0, 2, , 3]);
                                            if (Date.now() - startTime > maxDuration) {
                                                reject({});
                                                return [2];
                                            }
                                            return [4, aiResult.GET("/flow/getResult/$" + id, {}, null, { hiddenLoading: true })];
                                        case 1:
                                            result = _b.sent();
                                            if ((result === null || result === void 0 ? void 0 : result.code) === 200) {
                                                resolve({ value: (_a = result === null || result === void 0 ? void 0 : result.data) !== null && _a !== void 0 ? _a : {} });
                                                return [2];
                                            }
                                            if ((result === null || result === void 0 ? void 0 : result.code) === 500) {
                                                reject({});
                                                return [2];
                                            }
                                            if (result.code === 300) {
                                                setTimeout(poll, pollInterval);
                                            }
                                            return [3, 3];
                                        case 2:
                                            error_1 = _b.sent();
                                            if (Date.now() - startTime <= maxDuration) {
                                                setTimeout(poll, pollInterval);
                                            }
                                            else {
                                                reject({});
                                            }
                                            return [3, 3];
                                        case 3: return [2];
                                    }
                                });
                            }); };
                            poll();
                        })];
            }
        });
    });
};
